module.exports = __webpack_public_path__ + "b1efcddd5641e26907ce235b5b863fff.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/history/fi-2009.png
// module id = 412
// module chunks = 0